export enum CreateVirtualCardScreen {
  Pick = 'Pick',
  Standard = 'Standard',
  DecliningBalance = 'DecliningBalance',
  Recurring = 'Recurring',
  Multiple = 'Multiple',
  BillPay = 'BillPay',
  MultipleBillPay = 'MultipleBillPay',
  IssuerCycle = 'IssuerCycle',
}
